import React from 'react';

const ToggleMenu = ({ value, names, onClick }) => {
  const calculatedWidth = `${(1 / names.length) * 100}% - ${(0.5 / names.length)}rem`;
  const calculatedPosition = `${value * 100}%`;

  const handleClick = (index) => {
    onClick(index);
  };

  return (
    <div className="w-full h-13 relative flex bg-overlay-5 rounded-full font-medium p-1 cursor-pointer">
      <div
        className="h-[calc(100%-0.5rem)] absolute rounded-full bg-primary z-0 duration-300 ease-out"
        style={{
          width: `calc(${calculatedWidth})`,
          transform: `translateX(calc(${calculatedPosition}))`,
        }}
      ></div>
      {names.map((name, index) => (
        <div
          key={`toggle-menu-${index}`}
          className="flex-1 h-full flex justify-center items-center rounded-full z-10"
          onClick={() => handleClick(index)}
        >
          {name}
        </div>
      ))}
    </div>
  );
};

export default ToggleMenu;
